
import { serializable, alias, primitive } from 'serializr';

export class ProductDistributionEmissionData {

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('end_market_location', primitive()))
	endMarketLocation?: string;

	@serializable(alias('co2e', primitive()))
	co2e?: number;

	@serializable(alias('normalised_co2e', primitive()))
	normalisedCo2e?: number;

	@serializable(alias('leg_type', primitive()))
	legType?: string;

}